import { isClient } from "../../common/utils"
import { useState, useEffect } from "react"

const isPageScrolledToTop = () => isClient() && window.scrollY < 100

const useNavbar = () => {
  const [highlighted, setHighlighted] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)
  const toogleHighlighted = () => setHighlighted(!isPageScrolledToTop())

  const hideMenu = () => setMenuOpen(false)

  useEffect(() => {
    window.addEventListener("scroll", toogleHighlighted)
    window.addEventListener("resize", hideMenu)

    // initial check, wether scroll position is 0 or not
    toogleHighlighted()

    return () => {
      window.removeEventListener("scroll", toogleHighlighted)
      window.removeEventListener("resize", hideMenu)
    }
  }, [])

  return {
    highlighted,
    menuOpen,
    toggleMenu: () => setMenuOpen(!menuOpen),
  }
}

export default useNavbar
